import { render, staticRenderFns } from "./AditionalEditForm.vue?vue&type=template&id=3720451e&scoped=true"
import script from "./AditionalEditForm.vue?vue&type=script&lang=js"
export * from "./AditionalEditForm.vue?vue&type=script&lang=js"
import style0 from "./AditionalEditForm.vue?vue&type=style&index=0&id=3720451e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3720451e",
  null
  
)

export default component.exports